import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { HeaderAdmin } from '../../../components/molecues';
import { Table } from '../../../../common/components/atoms';
import { UserImportModal } from '../../organisms'
import { Button, Select, LoadingView } from '../../../../common/components/atoms';
import { ModalDialog } from '../../../../common/components/molecues';

import { checkNull } from '../../../../common/helper/commonHelper.js';
import { DialogMessage } from '../../../common/DialogMessage.jsx';

import { USERTYPE_TEXT, USERTYPE } from '../../../common/constants.js';
import { Pagenation } from '../../../common/Pagenation.jsx';

class UserCtrl extends Component {
    constructor(props) {
        super(props);

        this.Pagenation = new Pagenation();
        this.state = {
            type: "0",
            course: "-1",
            searchText: "",
            displayImport: false,
            displayDeleteDlg: false,
            userData: [],
            deleteReady: null,

            currentPage: 0,
            pageSeparation: 0,
            pagingList: [],
        }
    }

    componentDidMount() {
        this.props.dispatch({
            type: "CheckMaintenance_Saga"
        });
        this.props.dispatch({
            type: "LoadEnd"
        });
    }
    getUserList = () => {
        this.props.dispatch({
            type: "LoadStart"
        });
        this.props.dispatch({
            type: 'GetUserList_Saga',
            search: this.state.searchText,
            userType: this.state.type,
            course: this.state.course,
            onSuccess: this.onSuccess,
            onFailure: this.onFailure,
        });
    }
    getCourseTextToIndex(course) {
        let array = [];
        for(let key in this.props.course) {
            array[String(key)] = this.props.course[key].name;
        }

        for (let key in array) {
            if (array[key] === course) {
                return key;
            }
        }
        return "-1";
    }

    onSuccess = (users) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.createUserData(users);
        let today = new Date();
        for(let key in users) {
            this.props.dispatch({
                type: "GetSendCount_Saga",
                id: users[key].id,
                month: today.getFullYear() + "-" + ('0' + (today.getMonth() + 1)).slice(-2),
                course: this.getCourseTextToIndex(users[key].course),
                index: key,
                onSuccess: this.onSuccessSendCount,
                onFailure: this.onFailureSendCount,
            });
    
        }
    }
    onFailure = (status, error) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
    }

    onSuccessSendCount = (index, count) => {
        let user = this.state.userData;
        user[index].sendCount = count;
        this.setState({ 
            userData: user,
            pagingList: this.Pagenation.getList(user, this.state.currentPage)
         });
    }
    onFailureSendCount = (index) => {
        let user = this.state.userData;
        user[index].sendCount = "-";
        this.setState({ 
            userData: user,
            pagingList: this.Pagenation.getList(user, this.state.currentPage)
         });
    }

    onChangeUserType = (e) => {
        this.setState({ type: e.target.dataset.value });
    }
    onChangeCourse = (e) => {
        this.setState({ course: e.target.value });
    }

    onChangeSearch = (e) => {
        this.setState({
            searchText: e.target.value
        })
    }

    onClickColumn = (index) => {
    }
    onClickRow = (index) => {
        this.props.dispatch({
            type: 'UserEdit',
            user: this.state.pagingList[index],
        });
        this.props.history.push('/admin/user-edit');
    }
    onClickDelete = (index) => {
        if(this.props.userType === USERTYPE.ADMIN){
            this.setState({
                displayDeleteDlg: true,
                deleteReady: index,
            });
        }
    }

    createUserData(users) {
        let userData = [];
        for (let key in users) {
            let user = users[key];
            user.type = USERTYPE_TEXT[users[key].type];
            user.course = this.props.course && checkNull(users[key].course) ? this.props.course[users[key].course].name : "";
            user.disable = users[key].deleteFlg;
            userData.push(user);
        }
        this.setState({
            userData: userData,
            pagingList: this.Pagenation.getList(userData, this.state.currentPage)
        });
    }

    createTableProps() {
        const height = (window.innerHeight - 64 - 20 - 28 - 64) + "px";
        return {
            height: height,
            columns: {
                "ユーザーID": "id",
                "メールアドレス": "address",
                "種類": "type",
                "コース": "course",
                "送信回数": "sendCount",
                "入会日": "subscribeDate",
                "入金日": "paymentDate",
                "退会日": "unsubscribeDate",
                "休会開始日": "recessStartDate",
                "休会終了日": "recessEndDate",
                "利用開始日": "activateDate",
                "最終利用日時": "lastLoginDate",
            },
            data: this.state.pagingList,
            onClickColumn: this.onClickColumn,
            onClickRow: this.onClickRow,
            controls : {
                "delete" : {
                    onClick: this.onClickDelete,
                    contents: (
                    <TableContrl hidden={this.props.userType === USERTYPE.TRAINER}>
                        <i className="fas fa-trash" />
                    </TableContrl>
                    ),
                }
            }
        };
    }

    onSuccessDelete = (index) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        let id = this.state.pagingList[index].id;
        let users = this.state.userData;
        for(let key in users) {
            if(id === users[key].id) {
                users[key].disable = true;
            }
        }
        this.setState({
            userData: users,
            displayDeleteDlg: false,
            deleteReady: null,
        })
    }

    onClickDeleteCnf = () => {
        this.props.dispatch({
            type: "LoadStart"
        });
        let index = this.state.deleteReady;
        this.props.dispatch({
            type: "DeleteUser_Saga",
            id: this.state.pagingList[index].id,
            index: index,
            onSuccess: this.onSuccessDelete,
            onFailure: this.onFailure,
        });
    }

    onClickDlgCancel = () => {
        this.setState({
            displayDeleteDlg: false,
            deleteReady: null,
        });
    }

    createDeleteDlgProps() {
        let index = this.state.deleteReady;
        let address = this.state.deleteReady ? this.state.pagingList[index].address : "";
        let message = (
            <div>
                {address}を削除します。<br/>
                よろしいですか？<br/>
                <br/>
                復元ボタンで元に戻すことができます。
            </div>
        )
        return {
            display: this.state.displayDeleteDlg,
            contents: (
                <DialogMessage key="message" Title="確認" Message={message} />
            ),
            controls: {
                'OK': {
                    Color: '#000',
                    onClick: this.onClickDeleteCnf,
                },
                'キャンセル': {
                    Color: '#000',
                    onClick: this.onClickDlgCancel,
                },
            },
            type: 1,
        }
    }

    onClickSearch = (e) => {
        this.getUserList();
        this.setState({
            currentPage: 0,
        });
    }

    onCilckNewUser = (e) => {
        this.props.dispatch({
            type: 'UserEdit',
            user: null,
        });
        this.props.history.push('/admin/user-edit');
    }

    onCilckImportUser = (e) => {
        this.setState({ displayImport: true });
    }
    onClickImportClose = (e) => {
        this.setState({ displayImport: false });
    }

    onCilckBack = (e) => {
        if(this.props.userType === USERTYPE.ADMIN){
            this.props.history.push('/admin/top');
        }
        if(this.props.userType === USERTYPE.TRAINER){
            this.props.history.push('/admin/trainer/top');
        }
    }

    onClickPageIndex = (index) => {
        this.setState({ 
            currentPage: index,
            pagingList: this.Pagenation.getList(this.state.userData, index),
        });
    }
    onChageSeparation = (index) => {
        this.setState({
            pageSeparation: index,
            currentPage: 0,
            pagingList: this.Pagenation.getList(this.state.userData, 0),
        })
    }

    render() {
        const width = window.innerWidth + "px";
        const height = (window.innerHeight - 64 - 20) + "px";
        const propsHeader = {
            title: "ユーザー管理",
            history: this.props.history,
        }
        const propsImportModal = {
            dispatch: this.props.dispatch,
            display: this.state.displayImport,
            onClickImportClose: this.onClickImportClose,
            permission: this.props.permission,
        }
        const propsTable = this.createTableProps();
        const propsDeleteDlg = this.createDeleteDlgProps();
        let course = [];
        course["-1"] = "利用コース";
        for(let key in this.props.course) {
            course[String(key)] = this.props.course[key].name;
        }
        return (
            <Body>
                <HeaderAdmin {...propsHeader}></HeaderAdmin>
                <Contents Width={width} Height={height}>
                    <Controls>
                        <ControlsChild>
                            <Group hidden={this.props.userType === USERTYPE.TRAINER}>
                                <Radio Select={this.state.type === "-1"} data-value="-1" onClick={this.onChangeUserType}>全て</Radio>
                                <Radio Select={this.state.type === "0"} data-value="0" onClick={this.onChangeUserType}>一般</Radio>
                                <Radio Select={this.state.type === "1"} data-value="1" onClick={this.onChangeUserType}>トレーナー</Radio>
                                <Radio Select={this.state.type === "2"} data-value="2" onClick={this.onChangeUserType}>管理者</Radio>
                            </Group>
                            <Select array={course} onChange={this.onChangeCourse} value={this.state.course} />
                            <Input>
                                <input type="text" name="search" value={this.state.searchText} placeholder="ユーザーID または メールアドレス"
                                    onChange={this.onChangeSearch}></input>
                            </Input>
                            <SearchButton onClick={this.onClickSearch}>
                                <i className="fas fa-search" />
                            </SearchButton>
                            {this.Pagenation.getSelector(this.onChageSeparation)}
                        </ControlsChild>
                        <ControlsChild>
                            <div style={{display: 'flex', visibility: this.props.userType === USERTYPE.TRAINER? 'hidden':''}}>
                                <Button
                                    Color="#0077FF"
                                    Width="100px"
                                    onClick={this.onCilckNewUser}
                                    icon={(<i className="fas fa-user-plus" />)}
                                    text="新規作成" />
                                <Button
                                    Color="#0077FF"
                                    Width="100px"
                                    onClick={this.onCilckImportUser}
                                    icon={(<i className="fas fa-file-import" />)}
                                    text="インポート" />
                            </div>
                            <Button
                                Color="#888888"
                                Width="100px"
                                onClick={this.onCilckBack}
                                text="戻る" />
                        </ControlsChild>
                    </Controls>
                    <Results>
                        <Table {...propsTable} />
                    </Results>
                    <div>
                        {this.Pagenation.getPageIndex(this.state.userData, this.state.currentPage, this.onClickPageIndex)}
                    </div>
                </Contents>
                <ModalDialog name="delete-dialog" {...propsDeleteDlg} />
                <UserImportModal {...propsImportModal} />
                <LoadingView Display={this.props.loading} />
            </Body>
        )
    }
}

const mapStateToProps = store => {
    return {
        permission: store.login.user.permission,
        loading: store.loading.loading,
        course: store.setting.course,
        userType: store.login.user.type,
    }
};

const connectedUserCtrl = connect(mapStateToProps)(UserCtrl);
export { connectedUserCtrl as UserCtrl };

const Body = styled.div`
    overflow-x: hidden;
`;
const Contents = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    height: ${props => (props.Height)};
    padding-top: 20px;
`;
const Controls = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
const ControlsChild = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Group = styled.div`
    display: flex;
    visibility: ${props => props.hidden ? "hidden" : ""};
    justify-content: center;
    align-items: center;
    margin: 0 10px;
    div {
        border: 1px solid #888;
    }
    div:first-of-type {
        border-radius: 5px 0 0 5px;
        border-left: 1px solid #888;
    }
    div:nth-of-type(even) {
        border-left: none;
        border-right: none;
    }
    div:last-of-type {
        border-radius: 0 5px 5px 0;
        border-right: 1px solid #888;
    }
`;
const Radio = styled.div`
    color: ${props => props.Select ? "#fff" : "#888"};
    background-color: ${props => props.Select ? "#888" : "#fff"};
    padding: 2px 5px;
    cursor: pointer;
`;

const Input = styled.div`
    width: 320px;
    text-align: center;
    margin: 0 10px;
    input {
        width: 100%;
        padding: 4px 10px;
        border: 1px solid #888;
    }
`;
const SearchButton = styled.div`
    color: #888;
    margin-left: 20px;
    i {
        font-size: 18px;
    }
    cursor: pointer;
`;

const Results = styled.div`
    margin-top: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    overflow-y: auto;
`;

const TableContrl = styled.div`
    cursor: pointer;
    padding: 0 2px;
`;
